import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(
    @Inject('API_GATEWAY_URL') public gatewayUrl: string,
    private _http: HttpClient
    ) { }

  uploadFile(file: File): Observable<string> {
    return this._http.post<string>(`${this.gatewayUrl}/onstock/files`, this.getFormData(file));
  }

  removeFile(id: string): Observable<boolean> {
    return this._http.delete<boolean>(`${this.gatewayUrl}/onstock/files/${id}`);
  }

  uploadImage(file: File): Observable<string> {
    return this._http.post<string>(`${this.gatewayUrl}/onstock/images`, this.getFormData(file));
  }

  uploadVideo(file: File): Observable<string> {
    return this._http.post<string>(`${this.gatewayUrl}/onstock/videos`, this.getFormData(file));
  }

  private getFormData(file: File) {
    let formData = new FormData();
    formData.append('file', file, file.name);

    return formData;
  }
}
